/*
sohel 09/21/2022 2698849438 Fixed Client Maintainance Bugs
ashraf 09/22/2022 2698849438 fixed value validation in subscribe popup, add role button disabling
saikrishna 10/03/2022 2698849438 Feature: Added three fields in multiple places wherever required in client management
saikrishna 10/03/2022 2698849438 Fixed merge conflicts.
saikrishna 10/04/2022 2698849438 bugFix: fixexed bugs in column names
saikrishna 10/06/2022 2698849438 Removed unecesarry console.log statements
saikrishna 10/06/2022 2698849438 Fixed client maintenance bugs told by QA
Suresh Peddavoora 10/26/2022 2698849438  Added Class Name for Text Field Enhancements
Ashraf 11/15/2022 2698849438 Fixed form resetting issue

*/

import React, {useContext, useEffect, useState} from 'react';
import {
  Grid,
  Button,
  FormHelperText,
  TextField,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import * as Yup from 'yup';
import DateFnsUtils from '@date-io/date-fns';
import {Currency} from '../../../util/Currency';
import {ThemeContext} from '../../../themes/ThemeProvider';
import moment from 'moment';
import {Formik, Form} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import {
  postSubscribeServiceData,
  resetMessage,
  resetStatus,
} from '../../../redux/reducers/client-maintainance/ClientGeneral';
import PageLoader from '../../../components/PageLoader';
import {SuccessSnackbar} from '../../../components/CustomSnackBar';
import CopyAddressTable from './CopyAddressTable';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';

const rateTypeOptions = [
  {value: 'flat', key: 'Flat Fee'},
  {value: 'percentage', key: 'Percentage'},
];

const SubscribeServicePopup = ({
  rowData,
  parentRowData,
  subServiceTypeTableData,
  setSubServiceTypeTableData,
  setEditSubServiceDialog,
  historyData,
  setHistoryData,
  clientNumber,
  handleSubServiceDialog,
  companyType,
  prePopData,
}) => {
  const dispatch = useDispatch();
  const {subscribedService} = rowData;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [stepNo, setStepNo] = useState(1);
  const [errors1, setErrors] = useState(false);

  const [copyAddressTableData, setCopyAddressTableData] = useState([{
    clientCode: String(parentRowData?.clientId + rowData?.clientCodeSuffix),
    parentAddress: false,
    parentContact: false,
  }]);
  const {postRateCardStatus, isLoading, successMsg} = useSelector(
    ({clientGeneral}) => clientGeneral,
  );

  const initialValues = {
    endDate: null,
    effectiveDate: null,
    rateType: '',
    value: '',
    serviceStatus: 'renew',
    rateNote: '',
    newEndDate: null,
    debtorOverPayments: 'none',
    inflationAgreement: 'none',
    postageAgreement: 'none',
  };

  const validationSchema = Yup.object().shape({
    rateNote: Yup.string().max(500, 'Note cannot exceed 500 characters'),
    debtorOverPayments: Yup.string().test('null check', 'Debtor over payments remitted is required', function(fieldValue) {
      if (
        fieldValue === 'none'
      ) {
        return false;
      } else {
        return true;
      }
    }),
    inflationAgreement: Yup.string().test('null check', 'Inflation agreement is required', function(fieldValue) {
      if (
        fieldValue === 'none'
      ) {
        return false;
      } else {
        return true;
      }
    }),
    postageAgreement: Yup.string().test('null check', 'Postage agreement is required', function(fieldValue) {
      if (
        fieldValue === 'none'
      ) {
        return false;
      } else {
        return true;
      }
    }),
    rateType: subscribedService ?
      Yup.object()
        .nullable()
        .when('serviceStatus', {
          is: (val) => val === 'renew',
          then: Yup.object().nullable().required('Rate type is required'),
        }) :
      Yup.object().nullable().required('Rate type is required'),
    value: subscribedService ?
      Yup.string()
        .when('serviceStatus', {
          is: (val) => val === 'renew',
          then: Yup.string().required('Value is required'),
        })
        .test('is not 100', 'Value should not be greater than 100', function(fieldValue, context) {
          if (
            context.parent.rateType &&
              context.parent.rateType.value === 'percentage' &&
            Number(fieldValue) > 100
          ) {
            return false;
          } else {
            return true;
          }
        })
        .test('is Negative', 'Value can\'t be negative', function(fieldValue, context) {
          if (
            context.parent.rateType &&
            (context.parent.rateType.value === 'percentage' || context.parent.rateType.value === 'flat') &&
            Number(fieldValue) < 0
          ) {
            return false;
          } else {
            return true;
          }
        }) :
      Yup.string()
        .required('Value is required')
        .test('is not 100', 'Value should not be greater than 100', function(fieldValue, context) {
          if (
            context.parent.rateType &&
              context.parent.rateType.value === 'percentage' &&
            Number(fieldValue) > 100
          ) {
            return false;
          } else {
            return true;
          }
        })
        .test('is Negative', 'Value can\'t be negative', function(fieldValue, context) {
          if (
            context.parent.rateType &&
            (context.parent.rateType.value === 'percentage' || context.parent.rateType.value === 'flat') &&
            Number(fieldValue) < 0
          ) {
            return false;
          } else {
            return true;
          }
        }),
    effectiveDate: subscribedService ?
      null :
      Yup.date()
        .typeError('Invalid Date Format')
        .min(today, 'Start date should not be past date')
        .nullable()
        .required('Effective date is required'),
    newEndDate: subscribedService ?
      null :
      Yup.date()
        .typeError('Invalid Date Format')
        .test('newEndDate', 'End Date should be greater than Start Date', function(date, context) {
          const effectiveDate = moment(context.parent.effectiveDate).format('YYYY-MM-DD');
          const endDate = moment(date).format('YYYY-MM-DD');
          if (endDate > effectiveDate) {
            return true;
          } else {
            return false;
          }
        })
        .nullable(),
  });

  useEffect(() => {
    if (postRateCardStatus && postRateCardStatus?.status === 200) {
      setEditSubServiceDialog(false);
    }
    setTimeout(() => {
      dispatch(resetMessage());
      dispatch(resetStatus());
    }, 3000);
  }, [postRateCardStatus]);
  const onSubmit = (values, errors) => {
    if ((stepNo === 1 || stepNo === 2) && !errors1) {
      setStepNo(stepNo + 1);
    }
    // if (rowData?.unsubscribedOrInactive === "Inactive") {
    //   const { clientNumber, feeType, feeValue, clientRatecardId, isCurrentRate, serviceStartDt } =
    //     rowData;
    //   const { rateType, value, endDate, effectiveDate, serviceStatus, rateNote, newEndDate } =
    //     values;
    //   const format = "YYYY-MM-DD";
    //   const payload = {
    //     clientId: clientNumber,
    //     feeType: rateType && rateType.value.length > 0 ? rateType.value.toLowerCase() : feeType,
    //     feeValue: value && value.length > 0 ? value : feeValue,
    //     rateId: clientRatecardId,
    //     serviceEndDt: newEndDate && moment(newEndDate).format(format),
    //     serviceStartDt: effectiveDate
    //       ? moment(effectiveDate).format(format)
    //       : moment(getEffectiveDate(values)).format(format),
    //     // : moment(serviceStartDt).format(format),
    //     terminated: serviceStatus === "renew" ? "" : "Y",
    //     rateNotes: rateNote,
    //     endDate: isCurrentRate
    //       ? moment(endDate).format(format)
    //       : newEndDate && moment(newEndDate).format(format),
    //     isCurrentRate: isCurrentRate,
    //     subServiceType: rowData?.subServiceType,
    //   };
    //   dispatch(saveRateCard(payload));
    // } else {
    const payload = {
      clientCodeSuffix: rowData?.clientCodeSuffix ? rowData?.clientCodeSuffix : '',
      clientId: parentRowData?.clientId ? parentRowData?.clientId : '',
      clientName: parentRowData?.clientName ? parentRowData?.clientName : '',
      // clientServiceId: rowData?.clientServiceId,
      parentClientId: parentRowData?.parentClientId ? parentRowData?.parentClientId : '',
      serviceType: rowData?.serviceType ? rowData?.serviceType : '',
      subServiceType: rowData?.subServiceType ? rowData?.subServiceType : '',
      feeType: values.rateType.value,
      feeValue: values.value,
      rateNotes: values.rateNote,
      serviceStartDt: moment(values.effectiveDate).format('YYYY-MM-DD'),
      serviceEndDt: values.newEndDate ? moment(values.newEndDate).format('YYYY-MM-DD') : null,
      copyClientAddressRequest: copyAddressTableData.length > 0 ? copyAddressTableData : [],
      paymentsRemitted: values?.debtorOverPayments ? values?.debtorOverPayments : '',
      inflationAgreement: values?.inflationAgreement ? values?.inflationAgreement : '',
      postageAgreement: values?.inflationAgreement ? values?.inflationAgreement : '',
    };
    stepNo === 2 && dispatch(postSubscribeServiceData(payload));
    // }
  };
  return (
    <div>
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleBlur,
            touched,
            errors,
            resetForm,
          } = props;
          return (
            <Form noValidate autocomplete="off">
              {stepNo === 1 ?
                <div className="col">
                  <div className="rate-columns">
                    <div>
                      <>
                        <div className="block-styling mt-3">
                          <div className="form-row global-field-textfields">
                            <div className="col-sm-6  form-group">
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <GuiAutoComplete
                                  options={rateTypeOptions}
                                  getOptionLabel={(option) => {
                                    return option && option.key && option.key;
                                  }}
                                  classes={{
                                    option: classes.option,
                                  }}
                                  size="small"
                                  autoHighlight
                                  name="rateType"
                                  value={values.rateType}
                                  onBlur={handleBlur}
                                  disabled={values.serviceStatus === 'terminate'}
                                  renderInput={(params) => (
                                    <GuiTextField
                                      className={` multiselect-label ${classes.labelName} ${classes.selectLabel} ${classes.multiselectlabel}`}
                                      {...params}
                                      variant="outlined"
                                      fullWidth
                                      required
                                      label={subscribedService ? 'Rate Type' : 'Rate Type'}
                                      name="rateType"
                                      touched={touched?.rateType}
                                      error={Boolean(touched?.rateType && errors?.rateType)}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      placeholder="Select Rate Type"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                    />
                                  )}
                                  onChange={(_, data) => {
                                    setFieldValue('rateType', data);
                                  }}
                                />
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.rateType && errors && errors?.rateType}
                              </FormHelperText>
                            </div>
                            <div className="col-sm-6 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                value={values[`value`]}
                                placeholder={`Enter Value`}
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                label={subscribedService ? 'Value' : 'Value'}
                                disabled={values.serviceStatus === 'terminate' || !values.rateType}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onBlur={handleBlur}
                                required
                                fullWidth
                                touched={touched?.value}
                                error={Boolean(touched?.value && errors?.value)}
                                name={`value`}
                                InputProps={
                                  values[`rateType`] && values[`rateType`].value === 'flat' ?
                                    {
                                      startAdornment: <InputAdornment>$</InputAdornment>,
                                      inputComponent: Currency,
                                    } :
                                    values[`rateType`] && values[`rateType`].value === 'percentage' ?
                                      {
                                        endAdornment: <InputAdornment>%</InputAdornment>,
                                        inputComponent: Currency,
                                      } :
                                      {}
                                }
                                onChange={(e) => {
                                  setFieldValue(`value`, e.target.value);
                                }}
                              />
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.value && errors && errors?.value}
                              </FormHelperText>
                            </div>
                            <>
                              <div className="col-sm-6 form-group">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <Grid container>
                                    <KeyboardDatePicker
                                      className={` ${classes.labelName} ${classes.datePicker}`}
                                      format="MM/dd/yyyy"
                                      placeholder="MM/DD/YYYY"
                                      fullWidth
                                      value={values?.effectiveDate}
                                      minDate={new Date()}
                                      minDateMessage={
                                        'Effective Date should be greater than the latest record end Date'
                                      }
                                      name="effectiveDate"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      helperText={null}
                                      // disabled={prePopData ? false : true}
                                      inputVariant="outlined"
                                      label="Effective Date"
                                      onChange={(val) => {
                                        setFieldValue('effectiveDate', val);
                                      }}
                                      required
                                      error={touched.effectiveDate && errors?.effectiveDate}
                                      touched={touched && touched?.effectiveDate}
                                      autoOk
                                      margin="dense"
                                    />
                                  </Grid>
                                </MuiPickersUtilsProvider>
                                <FormHelperText
                                  style={{color: 'red'}}
                                  margin="dense"
                                  variant="outlined"
                                >
                                  {touched?.effectiveDate && errors && errors?.effectiveDate}
                                </FormHelperText>
                              </div>
                              <div className="col-sm-6 form-group">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <Grid container>
                                    <KeyboardDatePicker
                                      className={` ${classes.labelName} ${classes.datePicker}`}
                                      format="MM/dd/yyyy"
                                      placeholder="MM/DD/YYYY"
                                      fullWidth
                                      value={values.newEndDate}
                                      name="newEndDate"
                                      minDate={
                                        values.effectiveDate ?
                                          new Date(
                                            moment(values.effectiveDate)
                                              .add(1, 'days')
                                              .format('YYYY-MM-DD'),
                                          ) :
                                          new Date(
                                            moment(new Date()).add(1, 'days').format('YYYY-MM-DD'),
                                          )
                                      }
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      helperText={null}
                                      // disabled={prePopData ? false : !getEffectiveDate(values)}
                                      inputVariant="outlined"
                                      error={touched.newEndDate && errors?.newEndDate}
                                      touched={touched && touched?.newEndDate}
                                      label="End Date"
                                      onChange={(val) => {
                                        setFieldValue('newEndDate', val);
                                      }}
                                      autoOk
                                      margin="dense"
                                    />
                                  </Grid>
                                </MuiPickersUtilsProvider>
                                <FormHelperText
                                  style={{color: 'red'}}
                                  margin="dense"
                                  variant="outlined"
                                >
                                  {touched?.newEndDate && errors && errors?.newEndDate}
                                </FormHelperText>
                              </div>
                            </>
                            <div className={`col-sm-6 form-group ${classes?.selectdropdown}`}>
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <InputLabel>Debtor Over Payments Remitted <span style={{color: touched?.debtorOverPayments && errors && errors?.debtorOverPayments ? 
                                  'red' : ''}}>*</span></InputLabel>
                                <Select
                                  fullWidth
                                  name="debtorOverPayments"
                                  className={classes.labelName}
                                  // disabled={isFieldDisabled(subServiceTypeId)}
                                  // defaultValue="none"
                                  label="Debtor Over Payments Remitted"
                                  value={
                                    values[`debtorOverPayments`]
                                  }
                                  onBlur={handleBlur}
                                  error={errors[`debtorOverPayments`]}
                                  touched={touched && touched[`debtorOverPayments`]}
                                  // inputProps={{
                                  //   style: { position: blockScroll ? `absolute` : `` },
                                  // }}
                                  // onOpen={() => {
                                  //   // may required
                                  //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                                  //   setBlockScroll(true);
                                  //   // }
                                  // }}
                                  // onClose={() => {
                                  //   // may required
                                  //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                                  //   setBlockScroll(false);
                                  //   // }
                                  // }}
                                  onChange={(e) => {
                                    setFieldValue(`debtorOverPayments`, e.target.value);
                                  }}
                                >
                                  <MenuItem value="none" key="none">
                                    <span className="defaultSelected">Select Any</span>
                                  </MenuItem>
                                  <MenuItem value="send">Send</MenuItem>
                                  <MenuItem value="dont send">Dont Send</MenuItem>
                                </Select>
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.debtorOverPayments && errors && errors?.debtorOverPayments}
                              </FormHelperText>
                            </div>
                            <div className={`col-sm-6 form-group ${classes?.selectdropdown}`}>
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <InputLabel>Inflation Agreement <span style={{color: touched?.inflationAgreement && errors && errors?.inflationAgreement ? 
                                  'red' : ''}}>*</span></InputLabel>
                                <Select
                                  className={classes.labelName}
                                  fullWidth
                                  name={`inflationAgreement`}
                                  // disabled={isFieldDisabled(subServiceTypeId)}
                                  // defaultValue="none"
                                  value={
                                    values[`inflationAgreement`]

                                  }
                                  onBlur={handleBlur}
                                  error={errors[`inflationAgreement`]}
                                  touched={touched && touched[`inflationAgreement`]}
                                  // inputProps={{
                                  //   style: { position: blockScroll ? `absolute` : `` },
                                  // }}
                                  // onOpen={() => {
                                  //   // may required
                                  //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                                  //   setBlockScroll(true);
                                  //   // }
                                  // }}
                                  // onClose={() => {
                                  //   // may required
                                  //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                                  //   setBlockScroll(false);
                                  //   // }
                                  // }}
                                  onChange={(e) => {
                                    setFieldValue(`inflationAgreement`, e.target.value);
                                  }}
                                >
                                  <MenuItem value="none" key="none" selected>
                                    <span className="defaultSelected">Select Any</span>
                                  </MenuItem>
                                  <MenuItem value="Has Agreement">Has Agreement</MenuItem>
                                  <MenuItem value="No Agreement">No Agreement</MenuItem>
                                </Select>
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.inflationAgreement && errors && errors?.inflationAgreement}
                              </FormHelperText>
                            </div>
                            <div className={`col-sm-6 form-group ${classes?.selectdropdown}`}>
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <InputLabel>Postage Agreement <span style={{color: touched?.postageAgreement && errors && errors?.postageAgreement ? 
                                  'red' : ''}}>*</span></InputLabel>
                                <Select
                                  fullWidth
                                  name={`postageAgreement`}
                                  // disabled={isFieldDisabled(subServiceTypeId)}
                                  // defaultValue="none"
                                  value={
                                    values[`postageAgreement`]

                                  }
                                  onBlur={handleBlur}
                                  error={errors[`postageAgreement`]}
                                  touched={touched && touched[`postageAgreement`]}
                                  // inputProps={{
                                  //   style: { position: blockScroll ? `absolute` : `` },
                                  // }}
                                  // onOpen={() => {
                                  //   // may required
                                  //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                                  //   setBlockScroll(true);
                                  //   // }
                                  // }}
                                  // onClose={() => {
                                  //   // may required
                                  //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                                  //   setBlockScroll(false);
                                  //   // }
                                  // }}
                                  onChange={(e) => {
                                    setFieldValue(`postageAgreement`, e.target.value);
                                  }}
                                >
                                  <MenuItem value="none" key="none">
                                    <span className="defaultSelected">Select Any</span>
                                  </MenuItem>
                                  <MenuItem value="Has Agreement">Has Agreement</MenuItem>
                                  <MenuItem value="No Agreement">No Agreement</MenuItem>
                                </Select>
                              </FormControl>
                              <FormHelperText
                                style={{color: 'red'}}
                                margin="dense"
                                variant="outlined"
                              >
                                {touched?.postageAgreement && errors && errors?.postageAgreement}
                              </FormHelperText>
                            </div>
                          </div>
                        </div>
                      </>
                      <div className="col-sm-12 p-0 form-group">
                        <TextField
                          label={subscribedService ? 'Note' : 'Note'}
                          margin="dense"
                          variant="outlined"
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled={companyType === 'The WellFund, LLC'}
                          name="rateNote"
                          placeholder="Enter your note here"
                          multiline
                          fullWidth
                          error={!!errors?.rateNote}
                          maxRows={4}
                          value={values.rateNote}
                          onChange={(e) => {
                            setFieldValue('rateNote', e.target.value);
                          }}
                        />
                        <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                          {errors.rateNote ? errors.rateNote : ''}
                        </FormHelperText>
                      </div>
                    </div>
                  </div>
                </div> :
                stepNo >= 2 ?
                  <div className="col">
                    <div className="col confirmation-dialogue">
                      <p>
                        Client Code
                        {parentRowData?.clientId + rowData?.clientCodeSuffix}
                        will be created.
                      </p>
                    </div>
                    <div className="col-md-12 p-4">
                      <CopyAddressTable
                        copyAddressTableData={copyAddressTableData}
                        setCopyAddressTableData={setCopyAddressTableData}
                      />

                    </div>
                  </div> :
                  ''}
              <div className="button-spacing-mb">
                <Button
                  type="button"
                  onClick={() => {
                    if (stepNo === 2) {
                      setStepNo(stepNo - 1);
                    } else {
                      resetForm(initialValues);
                      setEditSubServiceDialog(false);
                    }
                  }}
                  variant="outlined"
                  className={`mx-1 reset-btn`}
                >
                  {stepNo === 1 ? 'Cancel' : 'Back'}
                </Button>
                <Button
                  type="submit"
                  variant="outlined"
                  className={`search-btn mx-1`}
                  onClick={() => {
                    if (Object.keys(errors).length > 0) {
                      setErrors(true);
                    } else {
                      setErrors(false);
                    }
                  }}
                >
                  {stepNo === 1 ? 'save' : 'subscribe'}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>

      {isLoading && <PageLoader />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default SubscribeServicePopup;
